import { useQuery } from '@tanstack/react-query';

import { LitigationEntity } from '../entities/LitigationEntity';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

const getLitigation = async ({
  shipmentId,
  makeRequest,
}: {
  shipmentId: string;
  makeRequest: any;
}): Promise<LitigationEntity | null> => {
  const { data, error } = await makeRequest({
    path: `/shipments/${shipmentId}/litigations`,
  });

  if (error) throw new Error(error);

  if (data.litigation === null) return null;

  return LitigationEntity.create(data.litigation);
};

type QueryFnType = typeof getLitigation;

type UseGetLitigation = {
  config?: QueryConfig<QueryFnType>;
  shipmentId: string;
};

export const useGetLitigation = ({ config, shipmentId }: UseGetLitigation) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useQuery<ExtractFnReturnType<any>>({
    ...config,
    queryKey: ['litigation', shipmentId],
    queryFn: () => getLitigation({ shipmentId, makeRequest }),
  });
};
